import React, { useEffect, useRef, useState } from 'react'
import {Box, Grid, GridItem, Heading, Image, Tab, TabList, TabPanel, TabPanels, Tabs} from '@chakra-ui/react'
import NavBar from '../../../elements/NavBar'
import { removeAll } from '../../../../utilities/authUtils'
import {useHistory, Link} from 'react-router-dom'
import * as routesNames from '../../../../constants/routes'
import IconkYC from '../../../../assets/images/Iconkyc.svg'
import { bindActionCreators } from 'redux'
import { ActionCreators } from '../../../../redux/actions'
import { connect, useSelector } from 'react-redux'
import InstaLoanEmiCalculator from './components/InstaLoanEmiCalculator'
import BulletLoanEmiCalculator from './components/BulletLoanEmiCalculator'
import PersonalLoanEmiCalculator from './components/PersonalLoanEmiCalculator'
import Loader from '../../../elements/loader'
import LoanCard from './components/LoanCard'
import CustomToast from '../../../elements/customToast'
import ImportantDialog from '../../../elements/ImportantDialog'
import LoanAppliedDialog from '../components/LoanAppliedDialog'
import RejectedIcon from '../../../../assets/images/decline.svg'
import FinancialLoanCalculator from './components/FinancialLoanCalculator'
import BusinessLoanEmiCalculator from './components/BusinessLoanEmiCalculator'
import moment from 'moment'
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { error } from 'pdf-lib'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const tabNames = [
  {
      id: 1,
      name: 'Insta Loan',
  },
  {
      id: 2,
      name: 'Bullet Loan',
  },
  {
      id: 3,
      name: 'Personal Loan',
  },
]
const tabNamecond =[
  
    {
      id: 1,
      name: 'Invoice Financing Loan',
  },
   
  {
    id: 2,
    name: 'Business Loan',
},

]
const ApplyLoan = (props) => {

  const { addToast } = CustomToast()
  const history = useHistory()
  const bankRef = useRef()
  const emp_get =sessionStorage.getItem("emp_type")
  const incomeRef = useRef()
  const itrRef = useRef()
  const InvoiceRef = useRef()
  const BankStatRef = useRef()
  const PrrofdelliveryRef = useRef()
  const gstSubmissionRef = useRef()
  const pdcRef = useRef()
  const cpAssesmentRef = useRef()
  const borrowerState = useSelector((state) => state.borrowerState)
  const masterState = useSelector((state) => state.masterState)
  const [inputValues, setInputValues] = useState({})
  const [activeTab, setActiveTab] = useState(0);
  const [productId, setProductId] = useState(null)
    const [is_bank_StatementProtected, setIs_bank_StatementProtected] = useState(false);
    const [is_bank_Statement2Protected, setIs_bank_Statement2Protected] = useState(false);
    const [is_Income_Protected, setIs_Income_Protected] = useState(false);
    const [is_Itr_Protected, setIs_Itr_Protected] = useState(false);
  const [bankStatement, setBankStatement] = useState(null)
  const [incomeStatement, setIncomeStatement] = useState(null)
  const [InvoiceStatement, setInvoiceStatement] = useState(null)
  const [Proof_DeliveryStatement, setProof_DeliveryStatement] = useState(null)
  const [itrStatement, setItrStatement] = useState(null)
  const [BankStatement2Statement, setBankStatement2Statement] = useState(null)
  const [GstPaidStatement, setGstPaidStatement] = useState(null)
  const [pdcData, setPdcData] = useState(null)
  const [selectedLoanType, setSelectedLoanType] = useState(null);
  const [cpAssesment, setCpAssesment] = useState(null)
  const [loanSuccess, setLoanSuccess] = useState(false)
  const [instaLoanDetails, setInstaLoanDetails] = useState({
    loanAmount: [0, 7000],
    roi: [0, 0.2],
    tenure: [0, 10],
  });
  const [bulletLoanDetails, setBulletLoanDetails] = useState({
    loanAmount: [0, 30000],
    roi: [0, 18],
    tenure: [0, 240],
  });
  const [personalLoanDetails, setPersonalLoanDetails] = useState({
    loanAmount: [0, 40000],
    roi: [0, 24],
    tenure: [0, 9],
  });
  const [financialLoanDetails, setFinancialLoanDetails] = useState({
    loanAmount: [0, 10000],
    roi: [0, 41],
    tenure: [0, 15],
  });
  const [businesslLoanDetails, setBusinessLoanDetails] = useState({
    loanAmount: [0, 100000],
    roi: [0, 41],
    tenure: [0, 6],
  });
  const [expectedROI, setExpectedROI] = useState({roi: [0, 23]});
  const [loanRange, setLoanRange] = useState(null);
  const [loanTenure, setLoanTenure] = useState([0, 0]);

  const userDetails = borrowerState?.getUserDashboardDetails?.data?.data
  const userData = masterState?.getCurrentUserDetails?.data?.data
  const dropdownData = masterState?.getDropdownData?.data?.data
  const productData = borrowerState?.getProductList?.data?.data
  const loanListStatusData = borrowerState?.getLoanListStatus?.data?.data
  const isKYCPending = (userDetails?.user?.iskyc === 0 && userDetails?.user?.form_completed_status === 0)
  const isKYCUnderReview = (userDetails?.user?.iskyc === 0 && userDetails?.user?.form_completed_status === 1)
  const isLoanApplied = (loanListStatusData?.[0]?.loan_status === '0' || loanListStatusData?.[0]?.loan_status === '1' || loanListStatusData?.[0]?.loan_status === '2' || loanListStatusData?.[0]?.loan_status === '3' || loanListStatusData?.[0]?.loan_status === '4')
  // const isLoanRejected = borrowerState?.getLoanListStatus?.data?.is_loan_applicable
  const isPersonalLoan = selectedLoanType?.max_tenure_limit && JSON.parse(selectedLoanType?.max_tenure_limit)
  const isBulletLoan = productData?.find((item) => item.product_id === 2)
  const isInstaLoan = productData?.find((item) => item.product_id === 3)
  const isFinancialLoan = productData?.find((item) => item.product_id === 17)
  const isBuisnessLoan = productData?.find((item) => item.product_id === 10)
  const loanTenureData = isPersonalLoan
  const randomProductId = 
  (productData || []).length > 0 
    ? productData.map(item => item?.product_id) 
    : [];
  const productDataMap = randomProductId.length > 0 
  ? randomProductId[Math.floor(Math.random() * randomProductId.length)] 
  : null;
  useEffect(() => {
    props.actions.getUserDashboardDetailsAction()
    props.actions.getCurrentUserDetailsAction()
    props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership' ,platform:"web",employment_type:emp_get})
    props.actions.getProductListAction({platform:"web",employment_type:emp_get})
    props.actions.getLoanListStatusAction({status: '0,1,2,3,4'})
  }, []);

  useEffect(() => {
    setInputValues({
      ...inputValues,
      premise_status: userData?.[0]?.personal_data?.premise_status,
      educational_qualification: userData?.[0]?.personal_data?.educational_qualification,
    })
  }, [userData])

  useEffect(() => {
    if (borrowerState?.applyLoan?.data?.success === true){
      addToast({message: borrowerState?.applyLoan?.data?.message, status: 'success'})
      props?.actions?.cleanUpToast()
      setInputValues({})
      setBankStatement(null)
      setIncomeStatement(null)
      setInvoiceStatement(null)
      setItrStatement(null)
      setProof_DeliveryStatement(null)
      setBankStatement2Statement(null)
      setGstPaidStatement(null)
      setCpAssesment(null)
      setSelectedLoanType(null)
      props.actions.getLoanListStatusAction({status: '0,1,2,3'})
      props.actions.getCurrentUserDetailsAction()
      props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership',platform:"web",employment_type:emp_get })
      setLoanSuccess(true)
    } else if (borrowerState?.applyLoan?.data?.success === false){
      addToast({message: borrowerState?.applyLoan?.data?.message, status: 'error'})
      props?.actions?.cleanUpToast()
      props.actions.getDropdownDataAction({ type: 'loan_purpose|company_sector|work_exp_level|premise_status|educational_qualification|buss_premise_ownership' ,platform:"web",employment_type:emp_get})
      props.actions.getCurrentUserDetailsAction()
    }
  }, [borrowerState?.applyLoan?.data])

  const handleLoans = (id,item) => {
    setSelectedLoanType(item)
    if (id === productId) {
      setProductId(null);
      setActiveTab(0);
    } else {
      setProductId(id);
      setInputValues({...inputValues, loanTenure :"" , loan_amount :"",invoice_issue_date:"",invoice_payment_date:"",loan_tenure:"",income_proof:"",bank_statement:"",itr_proof:""})
      if (id === 1) {
        setActiveTab(2);
      } else if (id === 2) {
        setActiveTab(1);
      } else {
        setActiveTab(0);
      } 
    }
  }

  const handleTabChange = (index) => {
    setActiveTab(index);
  }

  const handleChangeInstaLoan = (e, type) => {
    const updatedDetails = {...instaLoanDetails, [type]: e,}
    setInstaLoanDetails(updatedDetails)
  }

  const handleChangeBulletLoan = (e, type) => {
    const updatedDetails = {...bulletLoanDetails, [type]: e,}
    setBulletLoanDetails(updatedDetails)
  }

  const handleChangePersonalLoan = (e, type) => {
    const updatedDetails = {...personalLoanDetails, [type]: e,}
    setPersonalLoanDetails(updatedDetails)
  }
  const handleChangeFinancialLoan = (e, type) => {
    const updatedDetails = {...financialLoanDetails, [type]: e,}
    setFinancialLoanDetails(updatedDetails)
  }
  const handleChangeBuisnesslLoan = (e, type) => {
    const updatedDetails = {...businesslLoanDetails, [type]: e,}
    setBusinessLoanDetails(updatedDetails)
  }
  const handleExpectedROI = (e, type) => {
    const updatedDetails = {...expectedROI, [type]: e,}
    setExpectedROI(updatedDetails)
  }

  const handleLoanCalculator = () => {
    if (activeTab === 0) {
      if(productDataMap ==1 || productDataMap ==2 || productDataMap ==3 ){
        let totalPayableInterest = ((instaLoanDetails.roi[1]) * parseInt(instaLoanDetails.loanAmount[1]) * parseInt(instaLoanDetails.tenure[1])) / 100;
        let totalAmt = totalPayableInterest + parseInt(instaLoanDetails.loanAmount[1])
        return {totalInterest : totalPayableInterest.toFixed(2), totalAmount: totalAmt.toFixed(2)};
      }
      else if( productDataMap ==17){
     let totalPayableInterest = (parseFloat(financialLoanDetails.roi[1]) / 100) * parseInt(financialLoanDetails.loanAmount[1]) * parseInt(financialLoanDetails.tenure[1]);
        let totalAmt = totalPayableInterest + parseInt(financialLoanDetails.loanAmount[1])
        return {totalInterest : totalPayableInterest.toFixed(2), totalAmount: totalAmt.toFixed(2)};
      }
      else if( productDataMap ==10){
        var interest = parseInt(businesslLoanDetails.roi[1]) / 1200;
        var emi = Math.round(parseInt(businesslLoanDetails.loanAmount[1]) * interest / (1 - (Math.pow(1 / (1 + interest), parseInt(businesslLoanDetails.tenure[1])))) * 100) / 100;
        var totalPayable = Math.round((emi * parseInt(businesslLoanDetails.tenure[1])) * 100) / 100;
        var interestPayable = Math.round((totalPayable * 1 - parseInt(businesslLoanDetails.loanAmount[1]) * 1) * 100) / 100;
        return {emi : emi, totalPayable : totalPayable, interestPayable : interestPayable, interestRate : interest };   
      }
    }
    if (activeTab === 1) {
      let totalPayableInterest = (((parseInt(bulletLoanDetails.roi[1]) / 365) * parseInt(bulletLoanDetails.loanAmount[1]))/100) * parseInt(bulletLoanDetails.tenure[1]);
      let totalAmt = totalPayableInterest + parseInt(bulletLoanDetails.loanAmount[1])
      return {totalInterest : totalPayableInterest.toFixed(2), totalAmount: totalAmt.toFixed(2)};
    }
    if (activeTab === 2) {
      var interest = parseInt(personalLoanDetails.roi[1]) / 1200;
      var emi = Math.round(parseInt(personalLoanDetails.loanAmount[1]) * interest / (1 - (Math.pow(1 / (1 + interest), parseInt(personalLoanDetails.tenure[1])))) * 100) / 100;
      var totalPayable = Math.round((emi * parseInt(personalLoanDetails.tenure[1])) * 100) / 100;
      var interestPayable = Math.round((totalPayable * 1 - parseInt(personalLoanDetails.loanAmount[1]) * 1) * 100) / 100;
      return {emi : emi, totalPayable : totalPayable, interestPayable : interestPayable, interestRate : interest };
    }
  }

  const emiCalculator = handleLoanCalculator()

  const showOpenFileDialog = (type) => {
    if (type === 'bank_statement') {
      bankRef.current.click()
      return
    }
    if (type === 'income_proof') {
      incomeRef.current.click()
      return
    }
    if (type === 'itr_proof') {
      itrRef.current.click()
      return
    }
    if (type === 'invoice_copy') {
      InvoiceRef.current.click()
      return
    }
    if (type === 'gst_paid_submission') {
      gstSubmissionRef.current.click()
      return
    }
    if (type === 'proof_of_delivery') {
      PrrofdelliveryRef.current.click()
      return
    }
    if (type === 'bank_statement_2') {
      BankStatRef.current.click()
      return
    }
    if (type === 'cp_assesment') {
      cpAssesmentRef.current.click()
      return
    }
    if (type === 'pdc') {
      pdcRef.current.click()
      return
    }
  }

  const checkPDFProtection = (file) => {
    if (!(file instanceof Blob)) {
      return Promise.reject(new Error("Invalid file type. Expected a Blob or File."));
    }
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);
  
        try {
          await pdfjsLib.getDocument({ data: typedarray }).promise;
          resolve(false); // Not protected
        } catch (error) {
          if (error?.name === 'PasswordException') {
            resolve(true); // Protected
          } else {
            console.error('PDF parsing error:', error);
            reject(error);
          }
        }
      };
      fileReader.onerror = (err) => reject(err);
      fileReader.readAsArrayBuffer(file);
    });
  };


const onChangeFile = async (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  if (file.type !== 'application/pdf') {
    addToast({ message: `${type.replace(/_/g, ' ')} must be a file of type: PDF.`, status: 'error' });
    return;
  }

  try {
    const isProtected = await checkPDFProtection(file);
    // Always reset the relevant protection state first
    switch (type) {
      case "bank_statement":
        setIs_bank_StatementProtected(isProtected);
        if (isProtected)
          addToast({ message: 'Bank Statement is password-protected please enter your password.', status: 'warning' });
        break;
      case "bank_statement_2":
        setIs_bank_Statement2Protected(isProtected);
        if (isProtected)
          addToast({ message: 'Financial Year Bank Statement is password-protected please enter your password.', status: 'warning' });
        break;
      case "income_proof":
        setIs_Income_Protected(isProtected);
        if (isProtected)
          addToast({ message: 'Income Proof is password-protected please enter your password.', status: 'warning' });
        break;
      case "itr_proof":
        setIs_Itr_Protected(isProtected);
        if (isProtected)
          addToast({ message: 'ITR Proof is password-protected please enter your password.', status: 'warning' });
        break;
      default:
        break;
    }
  } catch (err) {
    addToast({ message: 'Something went wrong while checking the PDF please enter your password.', status: 'error' });
    return;
  }

  // Set file
  switch (type) {
    case 'income_proof':
      setIncomeStatement(file);
      break;
    case 'itr_proof':
      setItrStatement(file);
      break;
    case 'bank_statement':
      setBankStatement(file);
      break;
    case 'bank_statement_2':
      setBankStatement2Statement(file);
      break;
    case 'invoice_copy':
      setInvoiceStatement(file);
      break;
    case 'gst_paid_submission':
      setGstPaidStatement(file);
      break;
    case 'proof_of_delivery':
      setProof_DeliveryStatement(file);
      break;
    case 'pdc':
      setPdcData(file);
      break;
    case 'cp_assesment':
      setCpAssesment(file);
      break;
    default:
      addToast({ message: 'Unsupported document type.', status: 'error' });
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setInputValues((prevValues) => {
      let updatedValues = { ...prevValues, [name]: value };
  
      // Handle 'invoice_issue_date'
      if (name === "invoice_issue_date") {
        updatedValues.invoice_issue_date = moment(value).format('YYYY-MM-DD');
      }
  
      // Handle 'invoice_payment_date'
      if (name === "invoice_payment_date") {
        updatedValues.invoice_payment_date = moment(value).format('YYYY-MM-DD');
      }
  
      // Calculate 'credit_period' if both dates are present
      if (updatedValues.invoice_issue_date && updatedValues.invoice_payment_date) {
        updatedValues.credit_period = moment(updatedValues.invoice_payment_date).diff(
          moment(updatedValues.invoice_issue_date),
          'days'
        );
      }
      if (name === 'loan_amount') {
        const loanAmount = parseInt(value, 10);
        const loanRange = loanTenureData?.find((range) => loanAmount >= parseInt(range?.min_amount) && loanAmount <= parseInt(range?.max_amount));
        // if (loanRange) {
        //       setLoanRange({min_tenure: parseInt(loanRange.min_tenure), max_tenure: parseInt(loanRange.max_tenure)});
        //       setLoanTenure([parseInt(loanRange.min_tenure), parseInt(loanRange.max_tenure)]);
        //     } else {
        //       setLoanRange({ min_tenure: 0, max_tenure: 0 });
        //       setLoanTenure([0, 0]);
        //     }
        setLoanRange({
          min_tenure: loanRange ? parseInt(loanRange.min_tenure) : 0,
          max_tenure: loanRange ? parseInt(loanRange.max_tenure) : 0,
        });
        // Reset loan tenure when loan amount changes
        setLoanTenure([loanRange ? parseInt(loanRange.min_tenure) : 0, loanRange ? parseInt(loanRange.max_tenure) : 0]);
      }
      return updatedValues;
    });
  };
  
  const handleLoanTenure = (e) => {
    if (isPersonalLoan) {
      if (inputValues?.loan_amount) {
        let temp = [];
        temp[0] = 3;
        temp[1] = e[1];
        setLoanTenure(temp)
      } else {
        addToast({message: 'Please Enter Loan Amount', status: 'error'})
        return
      }
    }
  }
  const tryOpenPDFWithPassword = (file, password) => {
    if (!(file instanceof Blob)) {
      return Promise.reject(new Error("Invalid file type. Expected a Blob or File."));
    }
  
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
  
      fileReader.onload = async function () {
        const typedarray = new Uint8Array(this.result);
  
        try {
          await pdfjsLib.getDocument({
            data: typedarray,
            password
          }).promise;
  
          resolve(true); // Password correct
        } catch (error) {
          if (error?.name === 'PasswordException') {
            resolve(false); // Wrong password
          } else {
            console.error('PDF open error:', error);
            reject(error);
          }
        }
      };
  
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(file);
    });
  };
  
const handleValidatedLoanApply = async (productId, frequency, tenureLimit) => {
  const passwordChecks = [
    { type: 'bank_statement', isProtected: is_bank_StatementProtected, password: inputValues.bank_stmt1_password },
    { type: 'bank_statement_2', isProtected: is_bank_Statement2Protected, password: inputValues.bank_stmt2_password },
    { type: 'income_proof', isProtected: is_Income_Protected, password: inputValues.salary_slip_1_password },
    { type: 'itr_proof', isProtected: is_Itr_Protected, password: inputValues.itr_form16_password },
  ];

  for (const check of passwordChecks) {
    if (check.isProtected && !check.password) {
      addToast({ message: `Please enter password for ${check.type.replace(/_/g, ' ')}`, status: 'error' });
      return;
    }

    if (check.isProtected && check.password) {
      const fileMap = {
        'bank_statement': bankStatement,
        'bank_statement_2': BankStatement2Statement,
        'income_proof': incomeStatement,
        'itr_proof': itrStatement,
      };

      const file = fileMap[check.type];
      const valid = await tryOpenPDFWithPassword(file, check.password);
      if (!valid) {
        addToast({ message: `Incorrect password for ${check.type.replace(/_/g, ' ')}`, status: 'error' });
        return;
      }
    }
  }

  handleApplyLoan(productId, frequency, tenureLimit);
};

  const handleApplyLoan = async(loanTypeId, payment_frequency,max_tenure_limit,password,type) => {
  
    const loanAmount = Number(inputValues?.loan_amount);
    const InvoiceAmount = Number(inputValues?.invoice_amount);
    const isMultipleOfThousand = loanAmount % 1000 === 0;
    if (loanTypeId == 17 ){
      if (!inputValues?.invoice_amount) {
        addToast({message: 'Please Enter Invoice Amount', status: 'error'})
        return
      }
     
      if (Number(inputValues?.invoice_amount) <=0) {
        addToast({message: 'Please Enter Valid Invoice invoice loan amount' , status: 'error'});
        return
      }
     
      if (Number(inputValues?.loan_amount) < 10000) {
        addToast({message: 'Minimum loan amount is ₹10000', status: 'error'});
        return
      }
      if (Number(inputValues?.loan_amount ) > 300000) {
        addToast({message: 'Maximum loan amount is ₹300000', status: 'error'});
        return
      }
      if (!inputValues?.loan_tenure ) {
        addToast({message: 'Please Enter Your Loan Tenure', status: 'error'})
        return
      }
      if ((inputValues?.loan_tenure > 90 || inputValues?.loan_tenure == 0) ) {
        addToast({message: 'Please Enter Tenure Between 15 Days to 90 Days ', status: 'error'})
        return
      }
      if (!inputValues?.invoice_issue_date) {
        addToast({message: 'Please Select Your Invoice Issue Date', status: 'error'})
        return
      }
      if (!inputValues?.invoice_payment_date) {
        addToast({message: 'Please Select Your Invoice Payment Date', status: 'error'})
        return
      }
      if (!inputValues?.credit_period || !inputValues?.credit_period > 90 ) {
        addToast({message: 'Please Enter  Credit Period', status: 'error'})
        return
      }
     
      if ( inputValues?.credit_period <= 0 ) {
        addToast({message: 'Please Enter Valid Credit Period', status: 'error'})
        return
      }
      if ( inputValues?.credit_period > 90 ) {
        addToast({message: 'Please Select Valid Credit Period Upto 90 Days', status: 'error'})
        return
      }
     
      if (!inputValues?.company_establishment) {
        addToast({message: 'Please Select Total Company Establishment', status: 'error'})
        return
      }
     
      if (!inputValues?.avg_annual_turnover) {
        addToast({message: 'Please Enter Average Turn Over', status: 'error'})
        return
      }
      if (!inputValues?.buss_premise_ownership) {
        addToast({message: 'Please Enter House Ownership', status: 'error'})
        return
      }
      // if (!inputValues?.educational_qualification) {
      //   addToast({message: 'Please Enter Education Qualification', status: 'error'})
      //   return
      // }
    }
    else if(loanTypeId == 10){
      if (Number(inputValues?.loan_amount) < 100000) {
        addToast({message: 'Minimum loan amount is ₹100000', status: 'error'});
        return
      }
      if (Number(inputValues?.loan_amount) > 1000000) {
        addToast({message: 'Maximum loan amount is ₹300000', status: 'error'});
        return
      }
      if (!inputValues?.company_establishment) {
        addToast({message: 'Please Select Total Company Establishment', status: 'error'})
        return
      }
     
      if (!inputValues?.avg_annual_turnover || inputValues?.avg_annual_turnover < 100000) {
        addToast({message: 'Please Enter Average Turn Over', status: 'error'})
        return
      }
      if (!inputValues?.buss_premise_ownership) {
        addToast({message: 'Please Enter House Ownership', status: 'error'})
        return
      }
      if (!inputValues?.loan_tenure || inputValues?.loan_tenure < 6  || inputValues?.loan_tenure > 36 ) {
        addToast({message: 'Please Enter Your Valid Tenure', status: 'error'})
        return
      }
      if (!inputValues?.loan_purpose) {
        addToast({message: 'Please Select Loan Purpose', status: 'error'})
        return
      }
    }
    else {
      if (!inputValues?.loan_amount) {
        addToast({message: 'Please Enter Loan Amount', status: 'error'})
        return
      }
      if (loanTypeId === 3) {
        if (!isMultipleOfThousand) {
          addToast({message: 'Loan Amount Should be multiple of ₹1000', status: 'error'});
          return
        }
        if (loanAmount < 5000) {
          addToast({message: 'Minimum loan amount is ₹5000', status: 'error'});
          return
        }
        if (loanAmount > 10000) {
          addToast({message: 'Maximum loan amount is ₹10000', status: 'error'});
          return
        }
      }
      if (loanTypeId === 2) {
        if (loanAmount < 10000) {
          addToast({message: 'Minimum loan amount is ₹10000', status: 'error'});
          return
        }
        if (loanAmount > 50000) {
          addToast({message: 'Maximum loan amount is ₹50000', status: 'error'});
          return
        }
      }
      if (loanTypeId === 1) {
        if (loanAmount < 10000) {
          addToast({message: 'Minimum loan amount is ₹10000', status: 'error'});
          return
        }
        if (loanAmount > 300000) {
          addToast({message: 'Maximum loan amount is ₹300000', status: 'error'});
          return
        }
      }
      if ((loanTypeId === 3 || loanTypeId === 2) && !inputValues?.loan_tenure) {
        addToast({message: 'Please Enter Loan Tenure', status: 'error'})
        return
      }
      if (!inputValues?.loan_purpose) {
        addToast({message: 'Please Select Loan Purpose', status: 'error'})
        return
      }
      if (!inputValues?.current_company_name) {
        addToast({message: 'Please Enter Current Company Name', status: 'error'})
        return
      }
      if (!inputValues?.company_sector) {
        addToast({message: 'Please Select Company Sector', status: 'error'})
        return
      }
      if (!inputValues?.work_experience) {
        addToast({message: 'Please Select Total Work Experience', status: 'error'})
        return
      }
      if (!inputValues?.monthly_income) {
        addToast({message: 'Please Enter Monthly Income', status: 'error'})
        return
      }
      if (!inputValues?.premise_status) {
        addToast({message: 'Please Enter House Ownership', status: 'error'})
        return
      }
      if (!inputValues?.educational_qualification) {
        addToast({message: 'Please Enter Education Qualification', status: 'error'})
        return
      }
      if (loanTypeId !== 3) {
        if (!bankStatement) {
          addToast({message: 'Please Upload Bank Statement', status: 'error'})
          return
        }
        if (userData?.[0]?.employment_type === '1') {
          if (!incomeStatement) {
            addToast({message: 'Please Upload Income Proof / Salary Slip', status: 'error'})
            return
          }
        }
      }
    }
    const fileMap = {
      'income_proof': incomeStatement,
      'itr_proof': itrStatement,
      'bank_statement': bankStatement,
      'bank_statement_2': BankStatement2Statement,
    };
  
    const file = fileMap[type];
    // if (!file?.income_proof || !file?.bank_statement) {
    //   addToast({ message: 'File not found for validation.', status: 'error' });
    //   return;
    // }
    try {
      const isPasswordCorrect = await tryOpenPDFWithPassword(file, password);
      if (!isPasswordCorrect) {
        addToast({ message: 'Incorrect password. Please try again.', status: 'error' });
      } else {
        addToast({ message: 'PDF unlocked successfully.', status: 'success' });
  
        switch (type) {
          case "bank_statement":
            setIs_bank_StatementProtected(false);
            break;
          case "bank_statement_2":
            setIs_bank_Statement2Protected(false);
            break;
          case "income_proof":
            setIs_Income_Protected(false);
            break;
          case "itr_proof":
            setIs_Itr_Protected(false);
            break;
        }
      }
    } catch (err) {
      console.error("PDF open failed:", err);
    }
    if (is_bank_StatementProtected && !inputValues?.bank_stmt1_password) {
      addToast({message:'Please enter your bankstatement password for protected PDF.',status: "error"});
      return;
    }
    if (is_bank_Statement2Protected && !inputValues?.bank_stmt2_password) {
      addToast({message:'Please enter your financial year bankstatement password for protected PDF.',status: "error"});
      return;
    }
    
    if (is_Income_Protected && !inputValues?.salary_slip_1_password) {
      addToast({message:'Please enter your income password for protected PDF.',status: "error"});
      return;
    }
   if (is_Itr_Protected && !inputValues?.itr_form16_password) {
      addToast({message:'Please enter your itr  password for protected PDF.',status: "error"});
      return;
    } 
    
    // proceed with form submit
  ;
   let formData = new FormData();

    if(loanTypeId ==17) {
    formData.append("company_establishment", inputValues?.company_establishment);
    formData.append("invoice_payment_date", inputValues?.invoice_payment_date);
    formData.append("credit_period", inputValues?.credit_period);
    formData.append("invoice_issue_date", inputValues?.invoice_issue_date);
    formData.append("avg_annual_turnover", inputValues?.avg_annual_turnover);
    formData.append("buss_premise_ownership", inputValues?.buss_premise_ownership);
    formData.append("loan_amount", inputValues?.loan_amount);
    formData.append("invoice_amount", inputValues?.invoice_amount);
    formData.append("loan_type", loanTypeId);
    formData.append('expected_roi', expectedROI?.roi[1] ?? null)
    formData.append("educational_qualification", inputValues?.educational_qualification);
    formData.append("tenure", inputValues?.loan_tenure);
    formData.append("disbursal_consent", 'Y');

    formData.append("invoice_copy", InvoiceStatement);
    formData.append('proof_of_delivery', Proof_DeliveryStatement ?? "")
    formData.append('bank_statement_2', BankStatement2Statement ?? null)
    formData.append('gst_paid_submission', GstPaidStatement ?? null)
    formData.append('bank_statement_1', bankStatement ?? null)
    formData.append('itr_form16', itrStatement ?? null)
    formData.append('cp_credit_assessment', cpAssesment ?? null)
    formData.append('post_dated_cheque', pdcData ?? null)
    }
    else if(loanTypeId == 10){
    formData.append("company_establishment", inputValues?.company_establishment);
    formData.append("loan_amount", inputValues?.loan_amount);
    formData.append("buss_premise_ownership", inputValues?.buss_premise_ownership);
    formData.append('expected_roi', expectedROI?.roi[1] ?? null)
    formData.append("loan_type", loanTypeId);
    formData.append("tenure", inputValues?.loan_tenure);
    formData.append("disbursal_consent", 'Y');
    formData.append("avg_annual_turnover", inputValues?.avg_annual_turnover);

    formData.append('bank_statement_2', BankStatement2Statement ?? null)
    formData.append('gst_paid_submission', GstPaidStatement ?? null)
    formData.append('bank_statement_1', bankStatement ?? null)
    formData.append('itr_form16', itrStatement ?? null)
    formData.append('cp_credit_assessment', cpAssesment ?? null)
    formData.append('post_dated_cheque', pdcData ?? null)
    formData.append("loan_purpose", inputValues?.loan_purpose);

    }
    else{
      formData.append("loan_type", loanTypeId);
      formData.append("loan_amount", inputValues?.loan_amount);
      formData.append("itr_form16_password", inputValues?.itr_form16_password);
      formData.append("salary_slip_1_password", inputValues?.salary_slip_1_password);
      formData.append("bank_stmt1_password", inputValues?.bank_stmt1_password);
      formData.append("bank_stmt2_password", inputValues?.bank_stmt2_password);
      formData.append("tenure", max_tenure_limit ? loanTenure[1] : inputValues?.loan_tenure);
      formData.append("loan_purpose", inputValues?.loan_purpose);
      formData.append("premise_status", inputValues?.premise_status ?? userData?.personal_data?.premise_status);
      formData.append("educational_qualification", inputValues?.educational_qualification ?? userData?.personal_data?.educational_qualification);
      formData.append("company_name", inputValues?.current_company_name);
      formData.append("company_sector", inputValues?.company_sector);
      formData.append("work_exp_level", inputValues?.work_experience);
      formData.append("net_monthly_income", inputValues?.monthly_income);
      formData.append("disbursal_consent", 'Y');
      if (loanTypeId !== 3){
        formData.append('bank_statement_1', bankStatement ?? null)
        formData.append('itr_form16', itrStatement ?? null)
        formData.append('salary_slip_1', incomeStatement ?? null)
        formData.append('expected_roi', expectedROI?.roi[1] ?? null)
      }
    }
    props.actions.applyLoanAction(formData)
  }

  const handleCloseLoanSuccess = () => {
    setLoanSuccess(false)
  }

  const handleGoToLoanStatus = () => {
    history.push(routesNames.BORROWERLOANSTATUS)
  }

  const handleProfile = () => {
    history.push(routesNames.BORROWERPROFILE)
  }

  // const handleLogout = () => {
  //   removeAll()
  //   history.push(routesNames.LOGIN)
  // }
  return (
    <>
      {(masterState?.getCurrentUserDetails?.loading || borrowerState?.getProductList?.loading || borrowerState?.applyLoan?.loading) &&
        <div>
            <Loader />
        </div>
      }
      <Box className='dashboard_box bg_shadow'>
          <Grid className="main_grid_container align-items-center">
            <GridItem colSpan={8}>
              <Box className='d-flex align-items-center justify-content-between'>
                <Heading as="h2" className='font-poppins page_heading'>Loan Applications</Heading>
                <ImportantDialog />
              </Box>
            </GridItem>
            <GridItem colSpan={4}>
              <NavBar data={userData} handleProfile={handleProfile} />
            </GridItem>
          </Grid>
          <Grid className="main_grid_container align-items-center">
            <GridItem colSpan={7}>
              {isKYCUnderReview ?
                <Box mt={4} className='kyc_verify'>
                  <Heading as="h3" className='font-poppins'>
                    <Image src={IconkYC} />
                    Your documents under review
                    <Link to={routesNames.BORROWERKYC}>Tap to check your documents</Link>
                  </Heading> 
                </Box> : isKYCPending ?
                <Box mt={4} className='kyc_verify'>
                  <Heading as="h3" className='font-poppins'>
                    <Image src={IconkYC} />
                    Your ALPHAMONEY account needs Verification,
                    <Link to={routesNames.BORROWERKYC}>Tap to start your KYC</Link>
                  </Heading>
                </Box> : null
              }
              {isLoanApplied ?
                <Box mt={4} className='check_loan_status'>
                  <Image src={IconkYC} />
                  <Heading as="h3" className='font-poppins'>
                    Your loan application has been created. Please wait for 3 days to apply for a new loan.{' '}
                    <Link to={routesNames.BORROWERLOANSTATUS}>Check Loan Status</Link>
                  </Heading> 
                </Box> : 
              // isLoanRejected === 0 ? 
              //   <Box mt={4} className='check_loan_reject'>
              //     <Image src={RejectedIcon} />
              //     <Heading as="h3" className='font-poppins'>
              //       You're not eligible for a loan at this time. Please try again in 90 days.
              //     </Heading> 
              //   </Box> : 
              null 
              }
            </GridItem>
          </Grid>
          <Grid className="main_grid_container">
            <GridItem colSpan={7}>
              <Box mt={5}>
                <Heading as="h2" className='font-poppins block_heading' mb={3}>Loan Offerings</Heading>
                <LoanCard productData={productData} handleLoans={handleLoans} productId={productId} onChangeFile={onChangeFile}
                  showOpenFileDialog={showOpenFileDialog} bankStatement={bankStatement} incomeStatement={incomeStatement}
                  itrStatement={itrStatement} bankRef={bankRef} incomeRef={incomeRef} itrRef={itrRef} expectedROI={expectedROI}
                  handleExpectedROI={handleExpectedROI} dropdownData={dropdownData} handleApplyLoan={handleApplyLoan} handleValidatedLoanApply ={handleValidatedLoanApply}
                  handleChange={handleChange} inputValues={inputValues} isLoanApplied={isLoanApplied} isKYCPending={isKYCPending}
                  isKYCUnderReview={isKYCUnderReview} userData={userData} handleLoanTenure={handleLoanTenure} loanTenure={loanTenure}
                  loanRange={loanRange} gstSubmissionRef={gstSubmissionRef} PrrofdelliveryRef={PrrofdelliveryRef} BankStatRef={BankStatRef} InvoiceRef={InvoiceRef}
                  Proof_DeliveryStatement={Proof_DeliveryStatement}  BankStatement2Statement={BankStatement2Statement} GstPaidStatement={GstPaidStatement}
                  InvoiceStatement={InvoiceStatement} userDetails={userDetails} pdcRef={pdcRef} selectedLoanType={selectedLoanType} cpAssesmentRef={cpAssesmentRef}  cpAssesment={cpAssesment} pdcData={pdcData}
                  loanTenureData={loanTenureData} is_Income_Protected={is_Income_Protected}  is_bank_StatementProtected ={is_bank_StatementProtected} is_bank_Statement2Protected={is_bank_Statement2Protected} is_Itr_Protected={is_Itr_Protected}
              />
              </Box>
            </GridItem>
          {
              productData && productData.length > 0 && productData.map((item)=>(
                item?.product_id == 17 &&
            <GridItem colSpan={5} mt={5}>
                    <Box className='sticky_block'>
                    <Heading as="h2" className='font-poppins block_heading' mb={3}>Emi Calculator </Heading>
                    <Box className='emi_block bg_shadow'>
                      <Tabs className='tabs_container' index={activeTab} onChange={handleTabChange}>
                        <TabList className='tabs_list'>
                          {tabNamecond?.map((item, index) => {
                              return (
                                  <Tab key={index}>{item.name}</Tab>
                              )
                          })}
                        </TabList>
                        
                        <TabPanels>
                          {tabNamecond.map((item, index) => {
                            return (
                              <TabPanel key={index} className='tab_panel'>
                                {item.name == 'Invoice Financing Loan' &&
                                  <FinancialLoanCalculator handleChangeFinancialLoan={handleChangeFinancialLoan} emiCalculator={emiCalculator}
                                  financialLoanDetails={financialLoanDetails} isFinancialLoan={isFinancialLoan}
                                  />
                                }
                                {item.name === 'Business Loan' &&
                                 
                                 <BusinessLoanEmiCalculator emiCalculator={emiCalculator}  businesslLoanDetails={businesslLoanDetails} handleChangeBuisnesslLoan={handleChangeBuisnesslLoan} isBuisnessLoan={isBuisnessLoan}/>
                               }
                                {/* {
                                item.name === 'Business Loan' &&
                                <PersonalLoanEmiCalculator handleChangePersonalLoan={handleChangePersonalLoan} emiCalculator={emiCalculator}
                                personalLoanDetails={personalLoanDetails} isPersonalLoan={isPersonalLoan}
                              />
                                } */}
                              </TabPanel>
                            )
                          })}
                        </TabPanels>
                      
                      
                      </Tabs>
                    </Box>
                    </Box>
              </GridItem>
          ))}
            {
              productData && productData.length > 0 && productData.map((item)=>(
                item?.product_id == 1 || item?.product_id == 2 || item?.product_id == 3 &&
                <GridItem colSpan={5} mt={5}>
              
                <Box className='sticky_block'>
                <Heading as="h2" className='font-poppins block_heading' mb={3}>Emi Calculator </Heading>
                <Box className='emi_block bg_shadow'>
                  <Tabs className='tabs_container' index={activeTab} onChange={handleTabChange}>
                    <TabList className='tabs_list'>
                      {tabNames?.map((item, index) => {
                          return (
                              <Tab key={index}>{item.name}</Tab>
                          )
                      })}
                    </TabList>
                    <TabPanels>
                      {tabNames.map((item, index) => {
                        return (
                          <TabPanel key={index} className='tab_panel'>
                            {item.name === 'Insta Loan' && 
                              <InstaLoanEmiCalculator handleChangeInstaLoan={handleChangeInstaLoan} emiCalculator={emiCalculator}
                              instaLoanDetails={instaLoanDetails} isInstaLoan={isInstaLoan}
                              />
                            }
                            {item.name === 'Bullet Loan' &&
                              <BulletLoanEmiCalculator handleChangeBulletLoan={handleChangeBulletLoan} emiCalculator={emiCalculator}
                                bulletLoanDetails={bulletLoanDetails} isBulletLoan={isBulletLoan}
                              />
                            }
                            {item.name === 'Personal Loan' &&
                              <PersonalLoanEmiCalculator handleChangePersonalLoan={handleChangePersonalLoan} emiCalculator={emiCalculator}
                                personalLoanDetails={personalLoanDetails} isPersonalLoan={isPersonalLoan}
                              />
                            }
                          </TabPanel>
                        )
                      })}
                    </TabPanels>
                  </Tabs>
                </Box>
              </Box>
        </GridItem>
              )) 
            }
          </Grid>
      </Box>
      <LoanAppliedDialog loanSuccess={loanSuccess} handleCloseLoanSuccess={handleCloseLoanSuccess}
        handleGoToLoanStatus={handleGoToLoanStatus}
      />
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(ApplyLoan)